/* eslint-disable @typescript-eslint/ban-types */
import {
  ResultList,
  ResultListState,
  SearchEngine,
  buildResultList,
  buildResultsPerPage,
  loadAdvancedSearchQueryActions,
  loadQueryActions,
  loadSearchActions,
  loadSearchAnalyticsActions,
} from '@coveo/headless';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-nextjs/utils';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';

const FIELDS_TO_INCLUDE: string[] = [
  'trialminage',
  'trialmaxage',
  'trialphase',
  'trialcompletiondate',
  'trialenrollmenttype',
  'trialstatus',
  'trialenrollment',
  'trialorgstudyid',
  'isvirtual',
  'trialenrollingstatus',
  'trialname',
  'isfeaturedtrial',
  'featuredeprurl',
  'uri',
];

//Hook for saved Trials
const useSavedTrialsResultList = (engine: SearchEngine<{}>, resultsCount: number): any => {
  const userProfile = useSelector((state: RootState) => state.crProfile);
  const { updateQuery } = loadQueryActions(engine);
  const { executeSearch } = loadSearchActions(engine);
  const { logInterfaceLoad } = loadSearchAnalyticsActions(engine);
  const [state, setState] = useState<ResultListState>();
  const { sitecoreContext } = useSitecoreContext();
  useEffect(() => {
    if (isEditorActive() || sitecoreContext?.pageState === 'preview') {
      return;
    }
    if (typeof window !== 'undefined' && userProfile?.profileData?.trialIds?.length > 0) {
      let conditionAdvanceQuery = '';
      userProfile?.profileData?.trialIds?.map((item: any, index: number) => {
        const appendData =
          index === userProfile?.profileData?.trialIds?.length - 1
            ? `@trialname=${item} `
            : `@trialname=${item} OR `;
        conditionAdvanceQuery += appendData;
      });
      const searchQueryActionCreators = loadAdvancedSearchQueryActions(engine);

      const advancedSearchQueriesOptions: { aq: string } = {
        aq: conditionAdvanceQuery,
      };
      const searchQueryAction = searchQueryActionCreators.updateAdvancedSearchQueries(
        advancedSearchQueriesOptions
      );

      const resultList: ResultList = buildResultList(engine, {
        options: {
          fieldsToInclude: FIELDS_TO_INCLUDE,
        },
      });
      setState(resultList.state);

      resultList.subscribe(() => {
        setState(resultList.state);
      });
      engine.dispatch(searchQueryAction);
      engine.dispatch(executeSearch(logInterfaceLoad()));
    } else {
      setState(undefined);
    }
    return;
  }, [engine, updateQuery, userProfile?.profileData?.trialIds]);

  useEffect(() => {
    const resultsPerPage = buildResultsPerPage(engine, {
      initialState: { numberOfResults: 15000 },
    });
    resultsPerPage.set(resultsCount);
  }, [engine, resultsCount]);

  return { state };
};

export default useSavedTrialsResultList;
